import { render, staticRenderFns } from "./HomeworkUploadModal.vue?vue&type=template&id=332d6ade&"
import script from "./HomeworkUploadModal.vue?vue&type=script&lang=ts&"
export * from "./HomeworkUploadModal.vue?vue&type=script&lang=ts&"
import style0 from "./HomeworkUploadModal.vue?vue&type=style&index=0&id=332d6ade&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports